import React, { useEffect, useState } from 'react';
import event from '../../../images/icon/events.svg';
import { FaSpinner } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRevesedTranstionData } from '../../../Redux/Actions/EarningsAction';
import NewPagination from '../../Common/NewPagination';

const TransationHistory = (props) => {

    const dispatch = useDispatch();
    const transtionHisData = useSelector((state) => state.taskerHistoryData.data.transationHistory);
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState([]);
    const [loader, setLoader] = useState({
        fetch: true,
    });


    const fetchData = (page = currentPage) => {
        setLoader({
            ...loader,
            fetch: true
        });

        let formData = {
            page: page || 1
        };

        dispatch(fetchRevesedTranstionData("fetch-revesed-history", formData, setData, setLoader, loader, "transationHistory"));
    };

    const handlePageChange = (page) => {
        if (props.first) {
            if (page === 1) {
                setCurrentPage(1);
                fetchData(1);
            } else {
                setCurrentPage(page);
            }
        };
    }

    useEffect(() => {
        if (props.first) {
            if (transtionHisData && Object.keys(transtionHisData).length > 0) {
                setData(transtionHisData);
            } else {
                fetchData(1);
            }
        }
    }, [props.first]);


    useEffect(() => {
        if (props.first && currentPage > 1) {
            fetchData(currentPage);
        }
    }, [currentPage]);

    return (
        <>
            <div className="col-12">

                <>

                    <div className="account-block mx-2 mt-4 mb-3 mb-lg-5">
                        <div className="task_border d-flex justify-content-between border-0 pb-2">
                            <h6>All Reversed Transaction</h6>

                        </div>

                        <div className="table-responsive position-relative earnings_table mt-1 ">
                            <table className="table theme-table ">
                                <thead>
                                    <tr>
                                        <th>S.N.</th>
                                        <th>Task Title</th>
                                        <th>Type</th>
                                        <th>Date</th>
                                        <th>TSK coin</th>
                                        <th >Mode</th>

                                    </tr>
                                </thead>
                                {
                                    loader.fetch ? <div className='d-flex align-items-center justify-content-center' style={{ width: "100%", position: "absolute" }}><FaSpinner className='spin mt-3' style={{ fontSize: "20px" }} /></div> :
                                        <tbody>
                                            {data.length > 0 ? data.map((curElem, i) => (
                                                <tr key={i}>
                                                    <td data-label="Task ID">{i + 1}</td>
                                                    <td data-label="Task Title">{curElem.title}</td>
                                                    <td data-label="Type">{curElem.transction_type}</td>
                                                    <td data-label="Date"><img src={event} alt="" />{curElem.created}</td>
                                                    <td data-label="TSK coin">{curElem.amount} TSK coin</td>
                                                    <td data-label="Mode">

                                                        <div className='earn_status complete' style={{ width: "fit-content", backgroundColor: "#f8d7da", color: "#721c24", paddingBlock: "14px" }}> Reversed</div>

                                                    </td>


                                                </tr>
                                            )) :
                                                <td className='text-center mt-3 pt-2' colSpan={7}> No reversed transaction</td>
                                            }
                                        </tbody>
                                }
                            </table>

                            <div className='d-flex justify-content-end my-3'>

                                <NewPagination
                                    currentPage={currentPage}
                                    handlePageChange={handlePageChange}
                                    data={data}
                                    loader={loader.fetch}
                                />

                            </div>
                        </div>
                    </div>
                </>

            </div>
        </>
    )
}

export default TransationHistory